import { Injectable } from '@angular/core';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { DefaultHeadersApiPreInterceptor } from '../../../commons/core/http/default-headers-api.pre-interceptor';
import { DialogService } from "../../../commons/core/utils/dialog.service";
import { filter } from "rxjs/operators";

@Injectable()
export class UploadButtonService {
	private language: string = 'en-EN';
	private fileType: string;

	public constructor(private dialogService: DialogService) {
	}

	public getLanguage(): string {
		return this.language;
	}

	public setLanguage(language: string): void {
		this.language = language;
	}

	public setFileType(fyleType: string): void {
		this.fileType = fyleType;
	}

	public initUploader(url: string): FileUploader {
		const uploader = new FileUploader({
			authToken: DefaultHeadersApiPreInterceptor.AUTHORIZATION_HEADER,
			url
		});
		uploader.onErrorItem = () => {
			this.dialogService.errorModal('Error occurred during the import');
		};
		return uploader;
	}

	public async selectUploadFile(
		extension: string,
		uploader: FileUploader
	): Promise<any> {
		this.dialogService.selectFileModal(
			'Select a file as ' + this.fileType
		)
			.afterClosed()
		.pipe(
			filter((r) => !!r.file)
		)
		.subscribe((r) => {
			if (r && r.file) {
				uploader.queue.push(new FileItem(uploader, r.file, {}));
				this.startUpload(
					extension,
					'Are you sure you want to import this file?',
					uploader
				);
			}
		});
	}

	public startUpload(
		ext: string,
		display: string,
		uploader: FileUploader
	): void {
		if (!this.checkUploadedFile(ext, uploader)) {
			uploader.queue.pop();
			return;
		}
		this.dialogService.confirmModal(display)
			.afterClosed()
			.pipe(
				filter((r) => r.confirm)
			)
			.subscribe(() => {
				uploader.uploadAll();
				uploader.queue.pop();
			});
	}

	public checkFileFormat(ext: string, uploader: FileUploader): boolean {
		console.log(uploader.queue[0].file && uploader.queue[0].file.name);
		if (uploader.queue[0].file && uploader.queue[0].file.name) {
			return this.isExtensionValid(uploader.queue[0].file.name, ext);
		}
		return false;
	}

	public isExtensionValid(filename: string, ext: string): boolean {
		return filename.substr(filename.lastIndexOf('.')) === ext;
	}

	public displayExtensionError(uploader: FileUploader): void {
		this.dialogService.errorModal('The file format is not valid');
	}

	public checkUploadedFile(
		extension: string,
		uploader: FileUploader
	): boolean {
		if (!this.checkFileFormat(extension, uploader)) {
			this.displayExtensionError(uploader);
			return false;
		}
		return true;
	}
}
